import * as React from 'react';
import GeofenceOutlined from './geofence-outlined';
import GeofenceFilled from './geofence-filled';
import type { IconCombinedProps } from './types';
const GeofenceCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <GeofenceFilled ref={ref} {...rest} />;
  }
  return <GeofenceOutlined ref={ref} {...rest} />;
});
export default GeofenceCombined;